var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cms-page"},[(_vm.content)?_c('div',{staticClass:"row mt-30 px-3"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }